import React from 'react';
import { Helmet } from 'react-helmet-async';

const ServiceMeta = ({ 
  title, 
  description, 
  image, 
  url 
}) => {
  const baseUrl = 'https://dyvy-musicbox.preview.emergentagent.com';
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;
  const defaultImage = `${baseUrl}/og-default.jpg`;
  const ogImage = image || defaultImage;
  const pageTitle = `${title} | AGRP BOX`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default ServiceMeta;
